/* ==========================================================================
   Gulab Fit Finder — matches the "Size Chart in 2027" reel (velvetica.studio).
   01/03 LET'S FIND YOUR FIT (drag + steppers, live estimate)
   02/03 YOUR SHAPE (chest / stomach / hips)
   03/03 HOW DO YOU LIKE IT TO FIT? (slim / regular / relaxed)
   Result: BEST MATCH, fit %, size scale, fit matrix, ADD TO BAG.
   Mobile-first. Saved privately on-device. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';

  /* Brand's real bust chart (inches), from the Size Guide page. */
  var CHART = [
    ['XS', 36], ['S', 38], ['M', 40], ['L', 42],
    ['XL', 44], ['2XL', 46], ['3XL', 48], ['4XL', 50]
  ];
  var STORE_KEY = 'gulab-fit-v1';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function estimateBustIn(heightCm, weightKg) {
    /* Calibrated for women's bodies (Threads of Gulab customers).
       The video's t-shirt formula overestimates women's bust by ~4". */
    var bmi = weightKg / Math.pow(heightCm / 100, 2);
    return 0.8 * bmi + 18;
  }
  function cmToFtIn(cm) {
    var totalIn = cm / 2.54;
    var ft = Math.floor(totalIn / 12);
    var inch = Math.round(totalIn % 12);
    if (inch === 12) { ft += 1; inch = 0; }
    return ft + '′' + inch + '″';
  }
  function loadState() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (raw) { var s = JSON.parse(raw); s.page = 1; return s; }
    } catch (e) { /* ignore */ }
    return { heightCm: 165, weightKg: 60, gender: 'female', chest: 'average', stomach: 'average', hips: 'average', fitPref: 'regular', page: 1, viewSize: null };
  }
  function saveState(s) {
    try { var c = Object.assign({}, s); delete c.page; delete c.viewSize; window.localStorage.setItem(STORE_KEY, JSON.stringify(c)); } catch (e) { /* ignore */ }
  }

  function initOne(root) {
    var state = loadState();
    var hUnit = 'cm', wUnit = 'kg';
    var overlay = $('[data-fit-overlay]', root);
    var modal = $('[data-fit-modal]', root);
    var scroller = $('[data-fit-scroll]', root);

    /* The overlay must escape any transformed ancestor (Dawn's scroll-trigger
       animations apply transforms to sections, which would make position:fixed
       resolve against the ancestor instead of the viewport — the sheet opened
       half cut-off when tapped from a scrolled-down page). Moving it to
       <body> at init fixes this; all bindings below are element references
       so they are unaffected. */
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    /* All overlay content moved with it — query overlay descendants from the
       overlay element itself from here on. The trigger stays in the page
       flow, so it keeps the root scope. */
    var scope = overlay || root;

    /* ---------- Chart: product-specific when the PDP provides one ----------
       data-fit-chart = JSON [[size, bust], ...]; bust is inches (body basis)
       or a cm range string like "94–96" (garment basis).
       data-fit-basis = "body" | "garment". Absent = general chart. */
    var chart = CHART;
    var chartGarment = false;
    try {
      var chartAttr = root.getAttribute('data-fit-chart');
      if (chartAttr) {
        var parsedChart = JSON.parse(chartAttr);
        if (parsedChart && parsedChart.length) {
          chart = parsedChart;
          chartGarment = root.getAttribute('data-fit-basis') === 'garment';
        }
      }
    } catch (e) { /* fall back to the general chart */ }

    function garmentMid(rangeStr) {
      var parts = String(rangeStr).split(/[^0-9.]+/).filter(function (x) { return x !== ''; }).map(Number);
      if (parts.length >= 2) return (parts[0] + parts[1]) / 2;
      return parts[0] || 0;
    }

    /* ---------- Sizing engine ---------- */
    function shapeDelta() {
      var d = 0;
      if (state.chest === 'broader') d += 1;
      if (state.stomach === 'rounder') d += 1;
      if (state.hips === 'fuller') d += 1;
      return d;
    }
    function effectiveBust() {
      return estimateBustIn(state.heightCm, state.weightKg) + shapeDelta();
    }
    function pickSize() {
      var eb = effectiveBust();
      var best = 0, bestDiff = Infinity, i;
      if (chartGarment) {
        /* Garment measurements: smallest size whose garment-bust midpoint
           clears body bust + 2cm wearing ease (the loose-fit promise —
           zero-ease picks would be dishonest). */
        var targetCm = eb * 2.54 + 2;
        best = chart.length - 1;
        for (i = 0; i < chart.length; i++) {
          if (garmentMid(chart[i][1]) >= targetCm) { best = i; break; }
        }
        var midIn = garmentMid(chart[best][1]) / 2.54;
        /* Fit-preference nudges still apply against garment ease. */
        if (state.fitPref === 'slim' && best > 0 && midIn - eb > 1) best -= 1;
        if (state.fitPref === 'relaxed' && best < chart.length - 1 && eb - midIn > 1) best += 1;
        midIn = garmentMid(chart[best][1]) / 2.54;
        return { label: chart[best][0], index: best, bust: midIn };
      }
      chart.forEach(function (row, i) {
        var diff = Math.abs(row[1] - eb);
        if (diff < bestDiff) { bestDiff = diff; best = i; }
      });
      /* Fit preference nudges between-size calls */
      var chartBust = chart[best][1];
      if (state.fitPref === 'slim' && best > 0 && chartBust - eb > 1) best -= 1;
      if (state.fitPref === 'relaxed' && best < chart.length - 1 && eb - chartBust > 1) best += 1;
      return { label: chart[best][0], index: best, bust: chartBust };
    }
    function fitPct() {
      var p = 98;
      var nonAvg = (state.chest !== 'average' ? 1 : 0) + (state.stomach !== 'average' ? 1 : 0) + (state.hips !== 'average' ? 1 : 0);
      p -= nonAvg;
      if (state.fitPref !== 'regular') p -= 1;
      return Math.max(88, p);
    }

    /* ---------- Render ---------- */
    function render() {
      $('[data-fit-hval]', scope).textContent = hUnit === 'cm' ? Math.round(state.heightCm) : cmToFtIn(state.heightCm);
      $('[data-fit-hunitlabel]', scope).textContent = hUnit === 'cm' ? 'cm' : '';
      $('[data-fit-wval]', scope).textContent = wUnit === 'kg' ? Math.round(state.weightKg) : Math.round(state.weightKg * 2.20462);
      $('[data-fit-wunitlabel]', scope).textContent = wUnit;

      var fig = $('[data-fit-figure]', scope);
      if (fig) {
        var sy = 0.92 + (state.heightCm - 140) / 70 * 0.16;
        var sx = 0.9 + (state.weightKg - 35) / 145 * 0.2;
        fig.setAttribute('transform', 'translate(30 66) scale(' + sx.toFixed(3) + ' ' + sy.toFixed(3) + ') translate(-30 -66)');
      }

      var live = pickSize();
      $all('[data-fit-size]', scope).forEach(function (el) {
        if (el.closest('[data-fit-page="4"]')) return; /* result sets its own */
        el.textContent = live.label;
      });

      /* Estimated bust readout — lets the shopper cross-check against the chart. */
      var ebTxt = 'Est. bust \u2248 ' + Math.round(effectiveBust()) + '\u2033 / ' + Math.round(effectiveBust() * 2.54) + ' cm';
      $all('[data-fit-bust]', scope).forEach(function (el) { el.textContent = ebTxt; });

      $all('[data-fit-page]', scope).forEach(function (p) {
        p.hidden = parseInt(p.getAttribute('data-fit-page'), 10) !== state.page;
      });
      $all('[data-fit-nav]', scope).forEach(function (n) {
        n.hidden = parseInt(n.getAttribute('data-fit-nav'), 10) !== state.page;
      });
      var sn = $('[data-fit-stepnum]', scope);
      var stepsEl = sn ? sn.closest('.gulab-fit__steps') : null;
      if (state.page <= 3) {
        if (sn) sn.textContent = state.page === 1 ? '01' : state.page === 2 ? '02' : '03';
        if (stepsEl) stepsEl.style.display = '';
      } else if (stepsEl) {
        stepsEl.style.display = 'none';
      }

      if (state.page === 4) renderResult();
      saveState(state);
    }

    function renderResult() {
      var viewLabel = state.viewSize || pickSize().label;
      var idx = -1;
      chart.forEach(function (row, i) { if (row[0] === viewLabel) idx = i; });
      if (idx < 0) { idx = pickSize().index; viewLabel = chart[idx][0]; }
      var chartBustRaw = chart[idx][1];
      var chartBust = chartGarment ? garmentMid(chartBustRaw) / 2.54 : chartBustRaw;
      var eb = effectiveBust();

      /* Size displays */
      $all('[data-fit-page="4"] [data-fit-size]', scope).forEach(function (el) { el.textContent = viewLabel; });
      $('[data-fit-pct]', scope).textContent = fitPct() + '%';

      /* Size scale active */
      $all('[data-fit-scaleval]', scope).forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-fit-scaleval') === viewLabel);
      });

      /* Fit matrix: t in [0,1], 0 = snug, 0.5 = ideal, 1 = roomy.
         One chart step (2") moves the dot half the scale, so S/M/L/XL show visibly different fits. */
      var delta = eb - chartBust;
      var tChest = clamp(0.5 - delta / 4, 0.02, 0.98);
      var tWaist = clamp(0.5 - (delta - 1) / 4, 0.02, 0.98);
      var tLength = clamp(0.5 - (state.heightCm - 165) / 30, 0.02, 0.98);
      setDot('chest', tChest); setDot('waist', tWaist); setDot('length', tLength);

      /* Fit note */
      var avg = (tChest + tWaist + tLength) / 3;
      var note = 'Against your measurements this piece fits true to size.';
      if (avg < 0.38) note = 'Against your measurements this piece fits slightly snug — consider a size up for ease.';
      else if (avg > 0.62) note = 'Against your measurements this piece fits slightly relaxed.';
      if (state.fitPref === 'slim') note += ' Cut slim, as you like it.';
      if (state.fitPref === 'relaxed') note += ' Cut relaxed, as you like it.';
      $('[data-fit-note]', scope).textContent = note;
    }

    function setDot(row, t) {
      var dot = $('[data-fit-mrow="' + row + '"] [data-fit-mdot]', scope);
      if (dot) dot.style.left = 'calc(7rem + (100% - 7rem) * ' + (0.1667 + t * 0.6667).toFixed(4) + ')';
    }

    function setActive(attr, val) {
      $all('[' + attr + ']', scope).forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute(attr) === val);
      });
    }
    function setAriaChecked() {
      $all('[data-fit-pref]', scope).forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-fit-pref') === state.fitPref ? 'true' : 'false');
      });
    }

    /* ---------- Steppers ---------- */
    function bindStep(minus, plus, fn) {
      $(minus, scope).addEventListener('click', function () { fn(-1); });
      $(plus, scope).addEventListener('click', function () { fn(1); });
    }
    bindStep('[data-fit-hminus]', '[data-fit-hplus]', function (d) { state.heightCm = clamp(state.heightCm + d, 140, 210); render(); });
    bindStep('[data-fit-wminus]', '[data-fit-wplus]', function (d) { state.weightKg = clamp(state.weightKg + d, 35, 180); render(); });

    /* ---------- Drag to adjust (like the reel) ---------- */
    function addDrag(sel, get, set, pxPerUnit) {
      var el = $(sel, scope);
      if (!el) return;
      var active = false, startY = 0, startVal = 0;
      el.addEventListener('pointerdown', function (e) {
        active = true; startY = e.clientY; startVal = get();
        try { el.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        e.preventDefault();
      });
      el.addEventListener('pointermove', function (e) {
        if (!active) return;
        set(startVal + (startY - e.clientY) * pxPerUnit);
        render();
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        el.addEventListener(ev, function () { active = false; });
      });
    }
    addDrag('[data-fit-hdrag]', function () { return state.heightCm; }, function (v) { state.heightCm = clamp(v, 140, 210); }, 0.15);
    addDrag('[data-fit-wdrag]', function () { return state.weightKg; }, function (v) { state.weightKg = clamp(v, 35, 180); }, 0.12);
    addDrag('[data-fit-hdragdot]', function () { return state.heightCm; }, function (v) { state.heightCm = clamp(v, 140, 210); }, 0.15);
    addDrag('[data-fit-wdragdot]', function () { return state.weightKg; }, function (v) { state.weightKg = clamp(v, 35, 180); }, 0.12);

    /* ---------- Unit + gender toggles ---------- */
    $all('[data-fit-hunit]', scope).forEach(function (b) {
      b.addEventListener('click', function () { hUnit = b.getAttribute('data-fit-hunit'); setActive('data-fit-hunit', hUnit); render(); });
    });
    $all('[data-fit-wunit]', scope).forEach(function (b) {
      b.addEventListener('click', function () { wUnit = b.getAttribute('data-fit-wunit'); setActive('data-fit-wunit', wUnit); render(); });
    });
    $all('[data-fit-gender]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        state.gender = b.getAttribute('data-fit-gender');
        setActive('data-fit-gender', state.gender);
        render();
      });
    });

    /* ---------- Shape selectors ---------- */
    $all('[data-fit-shape]', scope).forEach(function (row) {
      var key = row.getAttribute('data-fit-shape');
      $all('[data-fit-val]', row).forEach(function (b) {
        b.addEventListener('click', function () {
          state[key] = b.getAttribute('data-fit-val');
          $all('[data-fit-val]', row).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          render();
        });
      });
    });

    /* ---------- Fit preference ---------- */
    $all('[data-fit-pref]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        state.fitPref = b.getAttribute('data-fit-pref');
        $all('[data-fit-pref]', scope).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        setAriaChecked();
        render();
      });
    });

    /* ---------- Pager ---------- */
    $all('[data-fit-next]', scope).forEach(function (b) {
      b.addEventListener('click', function () { state.page = Math.min(3, state.page + 1); state.viewSize = null; render(); if (scroller) scroller.scrollTop = 0;; });
    });
    $all('[data-fit-back]', scope).forEach(function (b) {
      b.addEventListener('click', function () { if (state.page > 1) { state.page -= 1; state.viewSize = null; render(); } });
    });
    var findBtn = $('[data-fit-find]', scope);
    if (findBtn) findBtn.addEventListener('click', function () { state.page = 4; state.viewSize = null; render(); if (scroller) scroller.scrollTop = 0;; });

    /* ---------- Size scale tap ---------- */
    $all('[data-fit-scaleval]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        state.viewSize = b.getAttribute('data-fit-scaleval');
        renderResult();
      });
    });

    /* ---------- ADD TO BAG ---------- */
    var addBtn = $('[data-fit-add]', scope);
    if (addBtn) addBtn.addEventListener('click', function () {
      var label = state.viewSize || pickSize().label;
      var btn = $('[data-fit-scaleval="' + label + '"]', scope);
      var variantId = btn ? btn.getAttribute('data-fit-variantid') : null;
      if (!variantId) { close(); return; }
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          close();
          /* Open the cart drawer via the header cart icon */
          var cartLink = document.querySelector('.header__icon--cart, a[href="/cart"]');
          if (cartLink) cartLink.click();
        })
        .catch(function () { addBtn.disabled = false; })
        .finally(function () { addBtn.disabled = false; });
    });

    /* ---------- Open / close ---------- */
    function open() {
      state.page = 1; state.viewSize = null;
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      render();
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { overlay.hidden = true; }, 320);
    }
    $('[data-fit-open]', root).addEventListener('click', open);
    $('[data-fit-close]', scope).addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    setActive('data-fit-gender', state.gender);
    setAriaChecked();
    render();
  }

  function init() {
    $all('.gulab-fit').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
